// Metadata for specific colors (Common palette)
const colorMetadata = [
    { id: 'tech-white', label: 'Tech White', swatch: '#F5F5F5' },
    { id: 'steel-gray', label: 'Steel Gray', swatch: '#7A7A7A' },
    { id: 'ocean-blue', label: 'Ocean Blue', swatch: '#1E5B6E' },
    { id: 'emerald-green', label: 'Emerald Green', swatch: '#7FAFA1' },
    { id: 'green', label: 'Green', swatch: '#5d6242' },
    { id: 'midnight-black', label: 'Midnight Black', swatch: '#000000' },
    { id: 'mocca-brown', label: 'Mocca-Brown', swatch: '#6D4C41' },
    { id: 'flame-red', label: 'Flame Red', swatch: '#D32F2F' },
    { id: 'mars-red', label: 'Mars Red', swatch: '#D32F2F' },
    { id: 'space-grey', label: 'Space Grey', swatch: '#666666' },
    { id: 'aurora-green', label: 'Aurora Green', swatch: '#455A64' },
    { id: 'golden-bronze', label: 'Golden Bronze', swatch: '#A1887F' },
    { id: 'orange', label: 'Orange', swatch: '#FF6B00' }
];

// Generic helper to generate complete 360 image arrays (0-36)
const generate360Colors = (basePath, availableColorIds) => {
    return availableColorIds.map(id => {
        const meta = colorMetadata.find(c => c.id === id) || { label: id, swatch: '#cccccc' };

        const images = [];
        for (let j = 0; j <= 36; j++) {
            images.push(`${basePath}/${id}/${j}.avif`);
        }

        return {
            id,
            label: meta.label,
            swatch: meta.swatch,
            images
        };
    });
};

// Generic helper to generate static image arrays (single image)
const generateStaticColors = (basePath, availableColorIds) => {
    return availableColorIds.map(id => {
        const meta = colorMetadata.find(c => c.id === id) || { label: id, swatch: '#cccccc' };

        return {
            id,
            label: meta.label,
            swatch: meta.swatch,
            images: [`${basePath}/${id}/0.png`] // Assuming 0.webp is the standard naming for static
        };
    });
};

export const modelsData = {
    'bj30': {
        name: 'BJ30 Hybrid',
        type: '360',
        image:'/assets/images/models/bj30.png',
        colors: generate360Colors('/assets/images/models/BJ30', [
            'steel-gray', 'midnight-black', 'emerald-green', 'space-grey'
        ])
    },
    'bj40-honor': {
        name: 'BJ40 HONOR',
        type: 'static',
        image:'/assets/images/models/bj40-honor.png',
        colors: generateStaticColors('/assets/images/models/BJ40-honor', ['green', 'space-grey', 'flame-red', 'midnight-black'])
    },
    'bj40-pro': {
        name: 'BJ40 PRO',
        type: '360',
        image:'/assets/images/models/bj40-pro.png',
        colors: generate360Colors('/assets/images/models/BJ40 PRO', [
            'steel-gray', 'midnight-black', 'orange', 'flame-red'
        ])
    },
    'u5-plus': {
        name: 'U5 PLUS',
        type: '360',
        image:'/assets/images/models/u5-plus.png',
        colors: generate360Colors('/assets/images/models/U5 PLUS', [
            'tech-white', 'steel-gray', 'flame-red'
        ])
    }
};

// Category Mapping for the Showcase
export const showcaseCategories = [
    {
        id: 'off-road',
        label: 'Off-road',
        models: ['bj30', 'bj40-honor', 'bj40-pro']
    },
    {
        id: 'sedan',
        label: 'Sedan',
        models: ['u5-plus']
    },
];

// Default export for backward compatibility
export const car360Data = modelsData['bj30'];
